/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offline_Banner_ItemsInputs */

const en_us2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 workout entry did not sync`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 workout entry did not sync`);
	return /** @type {LocalizedString} */ (`${i?.count} workout entries did not sync`)
	
};

const pt_br2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro do treino não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registro do treino não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} registros do treino não sincronizaram`)
	
};

const es_419_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registro del entrenamiento no se sincronizó`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registro del entrenamiento no se sincronizó`);
	return /** @type {LocalizedString} */ (`${i?.count} registros del entrenamiento no se sincronizaron`)
	
};

const pt_pt2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 registo do treino não sincronizou`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 registo do treino não sincronizou`);
	return /** @type {LocalizedString} */ (`${i?.count} registos do treino não sincronizaram`)
	
};

const fr_fr2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 entrée de séance non synchronisée`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 entrée de séance non synchronisée`);
	return /** @type {LocalizedString} */ (`${i?.count} entrées de séance non synchronisées`)
	
};

const de_de2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Trainingseintrag nicht synchronisiert`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Trainingseintrag nicht synchronisiert`);
	return /** @type {LocalizedString} */ (`${i?.count} Trainingseinträge nicht synchronisiert`)
	
};

const it_it2_offline_banner_items = /** @type {(inputs: Offline_Banner_ItemsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 voce dell'allenamento non sincronizzata`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 voce dell'allenamento non sincronizzata`);
	return /** @type {LocalizedString} */ (`${i?.count} voci dell'allenamento non sincronizzate`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 workout entry did not sync" |
* | "-1" | "1 workout entry did not sync" |
* | * | "{count} workout entries did not sync" |
*
* @param {Offline_Banner_ItemsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_banner_items = /** @type {((inputs: Offline_Banner_ItemsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Banner_ItemsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_banner_items(inputs)
	if (locale === "es-419") return es_419_offline_banner_items(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_banner_items(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_banner_items(inputs)
	if (locale === "de-DE") return de_de2_offline_banner_items(inputs)
	if (locale === "it-IT") return it_it2_offline_banner_items(inputs)
	return en_us2_offline_banner_items(inputs)
});
export { offline_banner_items as "offline.banner_items" }